import { render, staticRenderFns } from "./TokenExpiredForm.vue?vue&type=template&id=3bac6d24&scoped=true"
import script from "./TokenExpiredForm.vue?vue&type=script&lang=js"
export * from "./TokenExpiredForm.vue?vue&type=script&lang=js"
import style0 from "./TokenExpiredForm.vue?vue&type=style&index=0&id=3bac6d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac6d24",
  null
  
)

export default component.exports